<template>
    <span>
        <div class="modal-background"></div>
        <div class="map-selector-wrapper">
            <div class="map-selector-header">
                <button class="closeX" @click="close">close</button>
                <div class="select-location-text">Select a Location</div>
            </div>
            <GoogleMapsLocationSelector :coordinates="initialCoordinates" @locationUpdated="locationUpdated" class="map-selector"/>
            <div class="map-selector-selected">
                <div>Location: <MapCoordinates :coordinates="currentCoordinates"/></div>
                <div>Description: <EditableString class="descriptionInput" :value="initialDescription" @input="input=> currentDescription = input" :editable="true"/> </div>
            </div>
            <div class="map-selector-buttons">
                <button class="button" @click="close" @keypress="save">Cancel</button>
                <button class="button-primary" @click="save">Save</button>
            </div>
        </div>
    </span>
</template>

<script>
  export default {
    name: "MapSelectorModal",
    props: ["initialCoordinates", "initialDescription", "description"],
    data() {
      return {
        currentDescription: this.initialDescription,
        currentCoordinates: this.initialCoordinates
      }
    },
    methods: {
      close() {
        this.$emit('close');
      },
      save() {
        this.$emit('save', this.currentCoordinates, this.currentDescription);
      },
      locationUpdated(newLocation) {
        this.currentCoordinates = newLocation;
      }
    }
  }
</script>

<style scoped lang="scss">
    .descriptionInput {
        width: 25em;
        max-width: 100%;
    }
    .map-selector-buttons {
        display: flex;
        justify-content: center;
        margin: 1.5em 0;
    }
    .button {
        margin: 0 1em;
        color: $beaverpurple2;
        border: 1px solid $beaverpurple2;
        border-radius: 5px;
        width: 6em;
        height: 2em;
        line-height: 1;
        font-size: .9rem;
        //TODO: move
        font-family: system-ui, -apple-system, sans-serif;
        font-weight: 600;
    }

    .button-primary {
        @extend .button;
        background-color: $beaverpurple2;
        color: white;
    }
    .modal-background {
        width: 100%;
        height: 100%;
        position: fixed;
        background-color: grey;
        opacity: 0.7;
        top: 0;
        left: 0;
        z-index: 1000000000000;
    }

    .map-selector-wrapper {
        position: fixed;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        box-sizing: border-box;
        min-width: 360px;
        max-width: 600px;
        min-height: 360px;
        max-height: 600px;
        height: 100%;
        width: 100%;
        $wrapper-padding: 1.5em;
        padding: 0 $wrapper-padding;
        background: white;

        box-shadow: 0 0 2px 3px;//, 0 0 0px 0px inset;
        z-index: 1000000;

        z-index: 1000000000001;
        display:flex;
        flex-direction: column;

        .map-selector-header {

            display: grid;
            font-size: 20px;
            height: 3.5em;
            align-items: center;
            justify-items: center;
            .select-location-text {
                height: 1em;
            }
            .closeX {
                /*//margin-left: -$wrapper-padding + 1rem;*/
                /*margin-top: .6rem;*/
                /*//display: none;*/
                justify-self: left;

                position: absolute;
                font-family: 'Material Icons';
                text-decoration: none;
                user-select: none;
                outline: none;
                font-size: 28px;
                font-weight: 200;
                //padding: 1px;
                cursor: pointer;
                z-index: 1;
                line-height: 1;
                height: 1em;
                color: grey;
            }
        }

        .map-selector {
            //margin-top: 2.2em;
            width: 100%;
            flex-basis: 80%;
            flex-grow: 1;
            border-radius: 15px;
            overflow: hidden;
        }

        .map-selector-selected {
            margin: 0.5em;
        }
    }
</style>
